module.exports = __webpack_public_path__ + "magnet_logo_mobile.png?38ca89ee33f7e9ed5b4acee5949480b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/magnet_logo_mobile.png
// module id = 637
// module chunks = 0